module.exports = __webpack_public_path__ + "img/4.b07718a2.png";